import apiClient from './api'

function cleanParams(params = {}) {
  const result = {}
  Object.entries(params).forEach(([key, value]) => {
    if (value == null) return
    if (typeof value === 'string' && value.trim() === '') return
    result[key] = value
  })
  return result
}

const publicRecognitionAdminService = {
  async listPublicRecognitions(params = {}) {
    const res = await apiClient.get('/admin/public-recognitions', {
      params: cleanParams(params),
    })
    return res.data
  },

  async stats(params = {}) {
    const res = await apiClient.get('/admin/public-recognitions/stats', {
      params: cleanParams(params),
    })
    return res.data?.data || null
  },

  async getPublicRecognition(id) {
    const res = await apiClient.get(`/admin/public-recognitions/${id}`)
    return res.data?.data || null
  },

  async getPublicRecognitionLogs(id) {
    const res = await apiClient.get(`/admin/public-recognitions/${id}/logs`)
    return res.data?.data || []
  },

  async getPublicRecognitionAssetBlob(assetUrl) {
    const path = String(assetUrl || '').startsWith('/api/')
      ? String(assetUrl).slice('/api'.length)
      : assetUrl
    const res = await apiClient.get(path, { responseType: 'blob' })
    return res.data
  },
}

export default publicRecognitionAdminService
